import { useQuery } from 'react-query';
import { useAPIs } from 'src/hooks/useAPIs';
import { useRouter } from 'next/router';
import { isVideoTaxonomyInvalid } from 'src/modules/videos/utils/isVideoTaxonomyInvalid';
import { videoQueryByIdOrSlugFactory } from 'src/modules/videos/utils/videoQueryFactory';

export const useVideosDetailsQuery = () => {
  const apis = useAPIs();
  const router = useRouter();

  const videoIdOrSlug = String(
    router.query.slug ||
      router.query.bodyPartOrSlug ||
      router.query.subjectOrSlug,
  );

  const query = useQuery(videoQueryByIdOrSlugFactory(apis, videoIdOrSlug));

  if (!query.isLoading && (!query.data || isVideoTaxonomyInvalid(query.data))) {
    router.replace('/404');
  }

  return query;
};
